import axios from 'axios';
import store from '@/stores/store'
import router from '../config/router';
import jwtService from '@/services/jwt';

export default function setup() {
    axios.interceptors.request.use((config) => {
        if (config.url.includes('https://storage.googleapis.com/')
            || config.url.includes('https://powerbitcc.keybe.bio/power/bi')
            || config.url.includes('https://api.powerbi.com/v1.0/')
            || config.url.includes('/channel/api/auth/reset-password')
        ) return config

        if (!config.headers) config.headers = {}
        // console.log('INTERCEPTR')
        // console.log(config.headers)
        // console.log('INTERCEPTR')
        if(!(config && config.headers && typeof config.headers.appid === 'string' && config.headers.appid.trim() !== '')){
            config.headers.appid = '4b227777d4dd1fc61c6f884f48641d02b4d121d3fd328cb08b5531fcacdabf8a'
        } 
        config.headers.Authorization = store.state?.auth?.token ? `Bearer ${ store.state.auth.token }` : ''
        config.headers.refreshToken = store.state?.auth?.refreshToken ? `${ store.state.auth.refreshToken }` : ''
        // console.log('interceptor')
        return config
    })


    axios.interceptors.response.use(res => {
        // res.durationInMs = new Date().getTime() - res.config.meta.requestStartedAt
        return res;
    },
    async error => {
        // Validate ( token valid )
        if ( !error.response ) return Promise.reject(error)
        // validate 401 ( unauthorized ) -> try to refresh Token
        if (error.response.status === 401 ) {
            // Save origialRequest to try again
             const originalRequest = error.config;
            if (!originalRequest._retry){
                // define Retry to avoid loop
                originalRequest._retry = true;
                const refreshToken = store.state?.auth?.refreshToken
                if (refreshToken){
                    // Get Token by token Refresh and save in localstorage
                    let accessToken = await jwtService.refreshToken()
                    if (accessToken){
                        // Add access token to originalRequest header and retry
                        originalRequest.headers.Authorization = `Bearer ${accessToken}`                       
                        return axios(originalRequest);
                    } 
                }
            }
            // If it try with refresh and not working -> redirect to login page
            const requestUrl = error.config.url
            const errorMessage = error.response.data.message
            if( ( errorMessage == 'Error al autenticarse.' || errorMessage == 'No está autenticado.') ) {
                // get llogalstorage flat
                let  inProfile = localStorage.getItem('inProfile')
                if (requestUrl.includes('channel/api/profile') && !inProfile) {
                    // set flat to avoid loop
                    localStorage.setItem('inProfile', 'true')
                    return Promise.reject(error);
                }  else {
                    // If profile again return login and Reload
                    localStorage.clear()
                    router.push('/login')
                    location.reload(true)
                    return Promise.reject(error);
                }
                }
            }
            // add Here more Validations to interceptorErros
        throw error;
    });
}
